import { useMemo } from "react";
import { getFacilityLabel } from "../utils";

export default function useFacilityOptions(facilities) {
  return useMemo(() => {
    if (!Array.isArray(facilities) || facilities.length === 0) return [];

    const soldTo = [];
    const shipToBySoldTo = Object.create(null);

    for (const f of facilities) {
      const accountGroup = f?.accountGroup;

      if (accountGroup === "0001") {
        soldTo.push(f);
      } else if (accountGroup === "0002") {
        const parentKey = f.soldToNumber ?? f.soldToFacilityNumber ?? f.parentFacilityNumber;
        if (!parentKey) continue;
        (shipToBySoldTo[parentKey] ??= []).push(f);
      }
    }

    const result = [];

    for (const sold of soldTo) {
      const soldKey = sold.facilityNumber ?? sold.soldToNumber;
      const ships = shipToBySoldTo[soldKey] ?? [];

      if (ships.length === 0) {
        result.push({
          cat: getFacilityLabel(sold),
          key: getFacilityLabel(sold),
          facilityNumber: sold.facilityNumber,
          soldToFacility: "soldToFacility",
        });
      } else {
        for (const ship of ships) {
          result.push({
            cat: getFacilityLabel(sold),
            key: getFacilityLabel(ship),
            facilityNumber: ship.facilityNumber,
            shipToFacilities: "shipToFacilities",
          });
        }
      }
    }

    return result;
  }, [facilities]);
}
